import React from 'react';
import './Footer.css';

function Footer({ onPrivacyClick, onTermsClick, onAboutClick, onContactClick, onChangelogClick }) {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="app-footer">
            <div className="footer-content">
                <div className="footer-links">
                    <button onClick={onAboutClick} className="footer-link">
                        About
                    </button>
                    <span className="footer-separator">•</span>
                    <button onClick={onChangelogClick} className="footer-link">
                        Changelog
                    </button>
                    <span className="footer-separator">•</span>
                    <button onClick={onPrivacyClick} className="footer-link">
                        Privacy Policy
                    </button>
                    <span className="footer-separator">•</span>
                    <button onClick={onTermsClick} className="footer-link">
                        Terms of Service
                    </button>
                    <span className="footer-separator">•</span>
                    <button onClick={onContactClick} className="footer-link">
                        Contact
                    </button>
                    <span className="footer-separator">•</span>
                    <a
                        href="https://sunlabs.app/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="footer-link"
                    >
                        ☀ More at Sun Labs
                    </a>
                </div>
                <div className="footer-copyright">
                    © {currentYear} Click Mania. All rights reserved.
                </div>
            </div>
        </footer>
    );
}

export default Footer;